/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["i.fas.fa-check[_ngcontent-%COMP%]{color:#1ec623}@media only screen and (max-width:767px){.popupBtn[_ngcontent-%COMP%]{font-size:14px}}.mobileApp[_ngcontent-%COMP%]{text-align:center;padding:10px 10px 30px;background-color:var(--bkg-color2)}.mobileApp[_ngcontent-%COMP%]   .smartbanner-icon[_ngcontent-%COMP%]{padding-left:25px;color:var(--text-color2)}.mobileApp[_ngcontent-%COMP%]   .smartbanner-icon[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]:hover{-webkit-transform:scale(1.25);transform:scale(1.25);transition:1s}"];
export { styles as styles };
